import React, { useState, useEffect } from "react";
import { Row, Col, Card, Input, Button, Space, Form } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
// import { createTermsCondition } from "../redux/terms_and_conditions/action";
import { useHistory } from "react-router-dom";
import {
  getTermsConditions,
  createTermsCondition,
  updateTermsCondition,
} from "../../redux/terms_and_conditions/action";
const { TextArea } = Input;

function TermsAndConditions() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [searchText, setSearchText] = useState(false);
  const [searchedColumn, setSearchedColumn] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [textAreaValue, setTextAreaValue] = useState("");
  const [filteredInfo, setFilteredInfo] = useState(null);
  const [sortedInfo, setSortedInfo] = useState(null);
  const [termText, setTermText] = useState("");
  const {
    desc,
    term_condition,
    term_conditions,
    termLoading,
    termSuccess,
    termFail,
    updateTermLoading,
    updateTermSuccess,
    updateTermFail,
  } = useSelector((state) => state.terms_conditions);
  useEffect(() => {
    dispatch(getTermsConditions);
    setTermText(desc);
  }, [dispatch, desc]);

  let getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            setSearchInput(node);
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>

          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => setSearchInput(""), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const onSubmit = (value) => {
    const busAssociation = 1;
    // const value =
    // dispatch(createTermsCondition(value, history));
    const description = termText;
    const req = { busAssociation, description };
    dispatch(updateTermsCondition("1", req));
  };
  const handlePost = () => {
    if (termText !== "") {
      dispatch(createTermsCondition(termText, history));
    } else {
    }
  };

  let handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  let handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
    setFilteredInfo(null);
    setSortedInfo(null);
  };

  return (
    <div className="tabled">
      <Row centerd>
        <Col xs={23} xl={24}>
          <Card
            bordered={false}
            md="24"
            className="criclebox tablespace"
            title="Terms and conditions"
            style={{ height: "100%" }}
            extra={
              <Button
                // type="primary"
                icon={<ClockCircleOutlined />}
                size="large"
                onClick={() => onSubmit()}
              >
                Upload
              </Button>
            }
          >
            <Form
              name="basic"
              initialValues={{ remember: true }}
              onFinish={onSubmit}
              //   onFinishFailed={onFinishFailed}
              layout="vertical"
              className="row-col"
            >
              <Form.Item
                className="firstName"
                // label="First Name"
                // name="firstName"
                name="description"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please input description!",
                //   },
                // ]}
              >
                <TextArea
                  name="description"
                  value={termText}
                  type="text"
                  onChange={(e) => setTermText(e.target.value)}
                  style={{ width: "98%", height: "13rem", margin: "1rem" }}
                />
                <p style={{ color: "white" }}>{termText}</p>
              </Form.Item>
              {/* <Form.Item>
                <div
                  style={{
                    paddingTop: 30,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      width: "20%",
                    }}
                  >
                    Post
                  </Button>
                </div>
              </Form.Item> */}
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default TermsAndConditions;
